import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { Base64 } from 'js-base64';
import { DataService } from '../../services';
import { WhitelabelConfigStore } from '../../core/config/whitelabel-config.store';
import { SlideConfig } from '../../core/config/whitelabel-config.model';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FooterComponent implements OnInit {
  today = new Date();
  returning = false;

  constructor(
    private readonly router: Router,
    private readonly dataService: DataService,
    public readonly configStore: WhitelabelConfigStore
  ) { }

  ngOnInit() {
  }

  get config() {
    return this.configStore.snapshot.config;
  }

  get year(): number {
    return this.today.getFullYear();
  }

  get supportPhoneHref(): string {
    return `tel:${(this.config?.site.supportNumber ?? '').replace(/[^\d+]/g, '')}`;
  }

  get supportEmailHref(): string {
    return `mailto:${this.config?.site.supportEmail ?? ''}`;
  }

  get supportMapHref(): string {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(this.config?.site.address ?? '')}`;
  }

  get topRoutes() {
    return (this.config?.slides || []).filter(slide => slide.title).slice(0, 6);
  }

  searchTopRoute(route: SlideConfig): void {
    const cities = (route.description || '')
      .split(/\s*(?:→|->|–|—)\s*/)
      .map(city => city.trim())
      .filter(Boolean);

    if (cities.length < 2) {
      this.router.navigate(['/'], { fragment: 'search' });
      return;
    }

    this.clickTopCity(cities[0], cities[1]);
  }

  clickTopCity(departure: string, destination: string): void {
    const traveldate = formatDate(this.today, 'yyyy-MM-dd', 'en-KE');
    const search = {
      pickup: departure,
      dropoff: destination,
      pickupname: departure,
      dropoffname: destination,
      traveldate,
      returndate: '',
      returning: this.returning
    };

    const message = Base64.encode(JSON.stringify(search));
    this.dataService.changeMessage(message);
    this.router.navigate(['/booking', traveldate]);
  }
}
